module.exports = "/packs/media/images/icons/SavingsSteps_2-3051dc44fd3f205a3fbb4e2cc6108b6d.png";